module.exports = "<div class=\"contentWrapper vehicleUsers\">\n  <router-outlet></router-outlet>\n</div>"